export function camelize(value) {
  return value.replace(/(?:[_-])([a-z0-9])/g, function (_, _char) {
    return _char.toUpperCase();
  });
}
export function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}
export function dasherize(value) {
  return value.replace(/([A-Z])/g, function (_, _char2) {
    return "-" + _char2.toLowerCase();
  });
}